import { PLUS_FEATURES } from '@/features/subscription/constants/plusFeatures';
import { useTranslation } from 'react-i18next';

export const usePlusFeatures = () => {
  const { t } = useTranslation();

  return PLUS_FEATURES.map(({ key, icon, titleKey, descKey }) => ({
    key,
    icon,
    title: t(titleKey),
    desc: t(descKey),
  }));
};
